module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/My-Dad-Wrote-A-Porno.4ba0066.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/My-Dad-Wrote-A-Porno.jpg
// module id = Dr2Y
// module chunks = 0